import type { ColumnType } from 'antd/es/table';

export const resolveColumnKey = <T>(col: ColumnType<T>): string | null => {
  const key = col.key ?? col.dataIndex;
  return key ? String(key) : null;
};
